<!-- Enter log & pass -->
<mat-card class="example-card">
    <mat-card-header>
        <mat-card-title>Sign Up</mat-card-title>
        <mat-card-subtitle>Enter you data</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <!-- input for email & pass -->
        <form class="example-form" action="/action_page.php">
            <table class="example-full-width" cellspacing="0">
                <tr>
                    <td>
                        <!-- email -->
                        <mat-form-field class="example-full-width">
                            <mat-label>Enter you email:</mat-label>
                            <input type="email" matInput [(ngModel)]="loginForm.eemail" id="email" name="email"
                                placeholder="test@gmail" />
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <td>
                        <!-- pass -->
                        <mat-form-field class="example-full-width">
                            <mat-label>Enter you password:</mat-label>
                            <input type="password" matInput [(ngModel)]="loginForm.epassword" id="password"
                                name="password" placeholder="password" />
                        </mat-form-field>
                    </td>
                </tr>
            </table>
            <button mat-raised-button color="accent" (click)="entForm()">Sign Up</button>
        </form>


    </mat-card-content>
</mat-card>